import { TypedTranslation } from '../../../../translation/types';

enum ExploreTextKeys {
	LIVE_GAMES_TITLE = 'SPORTSBOOK_LIVE_GAMES_TITLE',
	LIVE_GAMES_SUBTITLE = 'SPORTSBOOK_LIVE_GAMES_SUBTITLE',
	UPCOMING_GAMES_TITLE = 'SPORTSBOOK_UPCOMING_GAMES_TITLE',
	UPCOMING_GAMES_SUBTITLE = 'SPORTSBOOK_UPCOMING_GAMES_SUBTITLE',
	HOT_LIVE_GAMES_TITLE = 'SPORTSBOOK_HOT_LIVE_GAMES_TITLE',
	HOT_LIVE_GAMES_SUBTITLE = 'SPORTSBOOK_HOT_LIVE_GAMES_SUBTITLE',
	HOT_UPCOMING_GAMES_TITLE = 'SPORTSBOOK_HOT_UPCOMING_GAMES_TITLE',
	HOT_UPCOMING_GAMES_SUBTITLE = 'SPORTSBOOK_HOT_UPCOMING_GAMES_SUBTITLE',
	FEATURED_SPORTS_TITLE = 'SPORTSBOOK_EXPLORE_FEATURED_SPORTS_TITLE',
	FEATURED_SPORTS_SUBTITLE = 'SPORTSBOOK_EXPLORE_FEATURED_SPORTS_SUBTITLE',
	NO_ODDS_AVAILABLE_FOR_LIVE_EVENTS = 'SPORTSBOOK_EXPLORE_NO_ODDS_AVAILABLE_FOR_LIVE_EVENTS',
	NO_ODDS_AVAILABLE_FOR_UPCOMING_EVENTS = 'SPORTSBOOK_EXPLORE_NO_ODDS_AVAILABLE_FOR_UPCOMING_EVENTS',
	RECOMMENDED_CASINO_GAMES_TITLE = 'SPORTSBOOK_EXPLORE_RECOMMENDED_CASINO_GAMES_TITLE',
	BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE = 'BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE',
	BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE_BETS = 'BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE_BETS',
	PRE_CANNED_CAROUSEL_TITLE = 'SPORTSBOOK_PRE_CANNED_CAROUSEL_TITLE'
}

export type ExploreTranslations = Readonly<TypedTranslation<typeof ExploreTextKeys>>;

export default ExploreTextKeys;
